<template>
    <div>
        <div class="vx-row">
            <div class="vx-col w-full">
                <vx-card titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters" class="user-list-filters mb-8"
                    :collapse-action="true" v-can="'view-grni-report'">
                    <div class="vx-row">
                        <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
                            <label class="text-sm opacity-100 text-bold">General Search</label>
                            <vs-input v-model="global_search" class="w-full"></vs-input>
                        </div>
                        <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
                            <label class="text-sm opacity-100 text-bold">Order From Date</label>
                            <flat-pickr class="w-full" :config="{ dateFormat: 'd/m/Y' }" v-model="from"
                                placeholder="Choose Date" />
                        </div>
                        <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
                            <label class="text-sm opacity-100 text-bold">Order To Date</label>
                            <flat-pickr class="w-full" :config="{ dateFormat: 'd/m/Y' }" v-model="to"
                                placeholder="Choose Date" />
                        </div>
                        <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
                            <label class="text-sm opacity-100 text-bold">Order Type</label>
                            <v-select :clearable="true" placeholder="" v-model="order_type" label="key"
                                :reduce="option => option.value" :options="order_type_options" multiple
                                :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
                        </div>
                        <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
                            <label class="text-sm opacity-100 text-bold">Invoice Status</label>
                            <v-select :clearable="true" placeholder="" v-model="payment_status" :reduce="option => option"
                                :options="['GRNI', 'Pre Invoice', 'Invoiced', 'Paid']" multiple
                                :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
                        </div>
                    </div>
                    <div class="vx-row mt-5">
                        <div class="vx-col w-full ml-auto">
                            <vs-button class="float-right mr-4" size="small" color="danger" type="border"
                                icon-pack="feather" v-on:click="onClickClearFilters">CLEAR
                            </vs-button>
                        </div>
                    </div>
                </vx-card>
                <vx-card class="pt-4 w-full" v-can="'view-grni-report'">
                    <template slot="actions">
                        <div class="flex">
                            <excel-download :name="'supplier-invoice-sheet'" :filters="fixed_filters"/>
                        </div>
                    </template>
                    <div slot="no-body" class="mt-4">
                        <vs-table v-can="'view-order'" :max-items="(meta.per_page) ? meta.per_page : 10" :data="order_list"
                            v-if="!is_loading" @sort="handleSort" :sst="true" stripe
                            class="table-dark-inverted table-auto vs-con-loading__container w-full">

                            <template slot="thead">
                                <vs-th width="15%" sort-key="created_at">DATE/TIME</vs-th>
                                <vs-th width="10%">ORDER TYPE</vs-th>
                                <vs-th width="10%">ORDER CODE</vs-th>
                                <vs-th width="10%">SUPPLIER NAME</vs-th>
                                <vs-th width="5%">CURRENCY</vs-th>
                                <vs-th width="2%">ITEM COUNT</vs-th>
                                <vs-th width="5%">TOTAL ORDER VALUE</vs-th>
                                <vs-th width="5%">ALREADY INVOICED VALUE</vs-th>
                                <vs-th width="5%">TOTAL INVOICED QUANTITY (KG)</vs-th>
                                <vs-th width="5%">GRNI TOTAL</vs-th>
                                <vs-th width="5%">TOTAL BALANCE DUE</vs-th>
                                <vs-th width="10%">SUPPLIER ACCOUNT NUMBER</vs-th>
                                <vs-th width="12%">ACTION</vs-th>
                            </template>

                            <template slot-scope="{data}">
                                <vs-tr style="cursor: pointer" :key="indextr" v-for="(tr, indextr) in data">


                                    <vs-td :data="data[indextr].created_at">
                                        {{ __dateTimeFormatter(data[indextr].created_at) }}
                                    </vs-td>

                                    <vs-td :data="data[indextr].type">
                                        {{ data[indextr].type }}
                                    </vs-td>

                                    <vs-td :data="data[indextr].order_number">
                                        <router-link :to="getColumnLink(data[indextr].type, data[indextr].order_id)"
                                            target="_blank">
                                            {{ data[indextr].order_number }}
                                        </router-link>
                                    </vs-td>

                                    <vs-td :data="data[indextr].supplier_name">
                                        <HyperLink :id="data[indextr].supplier_id" type="supplier">
                                            {{ data[indextr].supplier_name }}
                                        </HyperLink>
                                    </vs-td>

                                    <vs-td>
                                        <span v-if="data[indextr].items.length > 0">
                                            {{ data[indextr].items[0].currency || data[indextr].currency }}
                                        </span>
                                        <span v-else>N/A</span>
                                    </vs-td>

                                    <vs-td>
                                        <!-- {{ tr.items.length }} -->
                                        {{ itemCount(tr) }}
                                    </vs-td>

                                    <vs-td>
                                        {{ calculateTotalOrderValue(tr.items) }}
                                    </vs-td>

                                    <vs-td>
                                        {{ calculateAlreadyInvoicedTotal(tr.items, tr.type) }}
                                    </vs-td>

                                    <vs-td>
                                        {{ calculateAlreadyInvoicedTotalQuantity(tr.items, tr.type) }}
                                    </vs-td>

                                    <vs-td>
                                        {{ calculateGrniTotal(tr.items, tr.type) }}
                                    </vs-td>

                                    <vs-td>
                                        {{ calculateNotGrniTotal(tr.items) }}
                                    </vs-td>

                                    <vs-td :data="data[indextr].supplier_account_number">
                                        {{ data[indextr].supplier_account_number || 'N/A' }}
                                    </vs-td>

                                    <vs-td>
                                        <div class="vx-row">
                                            <vx-tooltip class="mr-2 mb-2" text="View Order Items" position="top">
                                                <vs-button class="" size="small" color="primary" type="border"
                                                    icon-pack="feather" icon="icon-eye"></vs-button>
                                            </vx-tooltip>
                                            <!-- <span v-if="tr.items.length === 1"> -->
                                            <vx-tooltip class="mr-2" :text="'Status Change to ' + payment_status.name"
                                                position="top" v-for="(payment_status, index) in payment_status_list"
                                                :key="index"
                                                v-if="tr.items.length === 1 && payment_status.before_status.includes(tr.items[0].payment_status) && $can('edit-grni-report') && tr.type !== 'Raw Material Order'">
                                                <vs-button size="small" :color="payment_status.color" type="border"
                                                    @click.stop="onClickStatusChangeConfirm(payment_status.value, tr.items[0].id, tr.type, tr.order_number)"
                                                    icon-pack="feather" :icon="payment_status.icon"
                                                    class="mb-2"></vs-button>
                                            </vx-tooltip>
                                            <!-- </span> -->
                                            <vx-tooltip class="mr-2"
                                                :text="'Status change to ' + payment_status.name"
                                                position="top"
                                                v-for="(payment_status, index) in payment_status_list"
                                                :key="'root-' + index"
                                                v-if="isRootStatusChangeButtonVisible(data[indextr], payment_status.name)">
                                                <vs-button size="small" :color="payment_status.color" type="border"
                                                    @click.stop="changeStatusRootLevel(data[indextr], payment_status.value)"
                                                    icon-pack="feather" :icon="payment_status.icon"></vs-button>
                                            </vx-tooltip>
                                        </div>
                                    </vs-td>

                                    <template class="expand-user" slot="expand">
                                        <div class="con-expand-users w-4/5">
                                            <vs-table :hoverFlat="true" class="mt-8 mb-8" :data="tr.items">
                                                <template slot="header">
                                                    <h5 class="mb-4">ORDER ITEMS</h5>
                                                </template>
                                                <template slot="thead">
                                                    <vs-th>ITS CODE/NAME</vs-th>
                                                    <vs-th>TOTAL ORDER ITEM QUANTITY (KG)</vs-th>
                                                    <vs-th>QUANTITY RECEIVED (KG)</vs-th>
                                                    <vs-th>QUANTITY PENDING (KG)</vs-th>
                                                    <vs-th>PRICE/KG</vs-th>
                                                    <vs-th>BATCH/ITEM STATUS</vs-th>
                                                    <vs-th>PAYMENT STATUS</vs-th>
                                                    <vs-th>ACTION</vs-th>
                                                </template>
                                                <template slot-scope="{data}">
                                                    <vs-tr :key="index_item" v-for="(tr_item, index_item) in data">

                                                        <vs-td>
                                                            {{ tr_item.code || '' }} <br> {{ tr_item.name || '' }}
                                                        </vs-td>
                                                        <vs-td>
                                                            {{ tr_item.quantity | format_quantity }}
                                                        </vs-td>
                                                        <vs-td>
                                                            {{ (Number(tr_item.quantity) -
                                                                Number(tr_item.quantity_pending_to_receive ? tr_item.quantity_pending_to_receive: 0)) |
                                                                format_quantity }}
                                                        </vs-td>
                                                        <vs-td>
                                                            {{ tr_item.quantity_pending_to_receive ? tr_item.quantity_pending_to_receive : 0 | format_quantity
                                                            }}
                                                        </vs-td>
                                                        <vs-td>
                                                            {{ currencySymbolGenerator(tr_item.currency) }}
                                                            {{ tr_item.price }}
                                                        </vs-td>
                                                        <vs-td>
                                                            {{ itemStatusGenerator(tr.type, tr_item.item_status, tr_item.batches, tr_item.quantity_pending_to_receive) }}
                                                        </vs-td>
                                                        <vs-td>
                                                            <!-- {{ tr_item.payment_status }}  -->
                                                            {{ itemPaymentStatusGenerator(tr.type, tr_item.payment_status, tr_item.batches) }}
                                                        </vs-td>
                                                        <vs-td>
                                                            <div class="vx-row"
                                                                v-if="$can('edit-grni-report') && tr.type !== 'Raw Material Order'">
                                                                <vx-tooltip class="mr-2"
                                                                    :text="'Status Change to ' + payment_status.name"
                                                                    position="top"
                                                                    v-for="(payment_status, index) in payment_status_list"
                                                                    :key="index"
                                                                    v-if="payment_status.before_status.includes(tr_item.payment_status)">
                                                                    <vs-button size="small" :color="payment_status.color"
                                                                        type="border"
                                                                        @click.stop="onClickStatusChangeConfirm(payment_status.value, tr_item.id, tr.type, tr.order_number)"
                                                                        icon-pack="feather"
                                                                        :icon="payment_status.icon"></vs-button>
                                                                </vx-tooltip>
                                                            </div>
                                                        </vs-td>
                                                        <template class="expand-user" slot="expand"
                                                            v-if="tr.type === 'Raw Material Order'">
                                                            <div class="con-expand-users w-4/5">
                                                                <vs-table :hoverFlat="true" class="mt-8 mb-8"
                                                                    :data="tr_item.batches">
                                                                    <template slot="header">
                                                                        <h5 class="mb-4">ITEM BATCH</h5>
                                                                    </template>
                                                                    <template slot="thead">
                                                                        <vs-th>BATCH CREATED DATE</vs-th>
                                                                        <vs-th>INVOICE NUMBER</vs-th>
                                                                        <vs-th>QUANTITY (KG)</vs-th>
                                                                        <vs-th>TOTAL VALUE ({{
                                                                            currencySymbolGenerator(tr_item.currency)
                                                                        }})</vs-th>
                                                                        <vs-th>QC STATUS</vs-th>
                                                                        <vs-th>PAYMENT STATUS</vs-th>
                                                                        <vs-th>NOTES</vs-th>
                                                                        <vs-th>ACTION</vs-th>
                                                                    </template>
                                                                    <template slot-scope="{data}">
                                                                        <vs-tr :key="index_item_batch"
                                                                            v-for="(tr_item_batch, index_item_batch) in data">

                                                                            <vs-td>
                                                                                {{
                                                                                    __dateTimeFormatter(tr_item_batch.created_at)
                                                                                }}
                                                                            </vs-td>

                                                                            <vs-td>
                                                                                {{ tr_item_batch.invoice_number || 'N/A' }}
                                                                            </vs-td>

                                                                            <vs-td>
                                                                                {{ tr_item_batch.quantity |
                                                                                    format_quantity }}
                                                                            </vs-td>

                                                                            <vs-td>
                                                                                {{ Number(tr_item_batch.quantity * tr_item.price).toFixed(2) }}
                                                                            </vs-td>

                                                                            <vs-td>
                                                                                {{ tr_item_batch.qc_test.q_c_status || '' }}
                                                                            </vs-td>

                                                                            <vs-td>
                                                                                {{ tr_item_batch.payment_status || '' }}
                                                                            </vs-td>

                                                                            <vs-td>
                                                                                {{ tr_item_batch.note || '' }}
                                                                            </vs-td>

                                                                            <vs-td>
                                                                                <div class="vx-row">
                                                                                    <vx-tooltip class="mr-2"
                                                                                        :text="'Status Change to ' + payment_status.name"
                                                                                        position="top"
                                                                                        v-for="(payment_status, index) in payment_status_list"
                                                                                        :key="index"
                                                                                        v-if="payment_status.before_status.includes(tr_item_batch.payment_status)">
                                                                                        <vs-button size="small"
                                                                                            :color="payment_status.color"
                                                                                            type="border"
                                                                                            @click.stop="onClickRmBatchStatusChangeConfirm(payment_status.value, tr_item_batch.id, tr.order_number)"
                                                                                            icon-pack="feather"
                                                                                            :icon="payment_status.icon"></vs-button>
                                                                                    </vx-tooltip>
                                                                                </div>
                                                                            </vs-td>



                                                                        </vs-tr>
                                                                    </template>
                                                                </vs-table>
                                                            </div>
                                                        </template>
                                                    </vs-tr>
                                                </template>
                                            </vs-table>
                                        </div>
                                    </template>

                                </vs-tr>
                            </template>


                        </vs-table>
                        <vs-pagination v-on:changeMaxItems="changePage" :size-array="meta.total ? meta.total : 20"
                            v-if="!is_loading" :max-items="perPage" description-body="Rows per page"
                            description-connector="of" description-title="Records" description
                            :description-items="descriptionItems" :total="(meta.last_page) ? meta.last_page : 0"
                            v-model="page" class="p-5" v-can="'view-grni-report'"></vs-pagination>

                    </div>
                </vx-card>
            </div>
        </div>
    </div>
</template>
  
<script>
import vSelect from 'vue-select'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import Filter from '@/mixins/filter';
const FinancialRepository = RepositoryFactory.get('financial')
const InventoryRepository = RepositoryFactory.get('inventory')

import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import { defaultPagination, perPageList } from "../../../constants/config";

import flatPickr from "vue-flatpickr-component";
import 'flatpickr/dist/flatpickr.css'
import moment from 'moment';

export default {
    name: 'GrniList',
    data() {
        return {
            order_list: [],
            filters: {},
            page: 1,
            total: 0,
            meta: {},
            sort: '',
            from: null,
            to: null,
            order_type: '',
            payment_status: '',
            customerId: '',
            global_search: '',
            is_on_create: false,
            perPage: defaultPagination,
            descriptionItems: perPageList,
            order_type_options: [
                { key: 'Raw Material Order', value: 'rm-order' },
                { key: 'Sundry Order', value: 'sundry-order' },
                { key: 'Other Service Order', value: 'other-order' }
            ],
            payment_status_list: [
                // { name: 'Pre Invoice', value: 'pre-invoice', color: 'warning', icon: 'icon-check' },
                { name: 'GRNI', value: 'GRNI', color: 'warning', icon: 'icon-dollar-sign', before_status: ['Pre Invoice'] },
                { name: 'Invoiced', value: 'Invoiced', color: 'warning', icon: 'icon-dollar-sign', before_status: ['GRNI'] },
                { name: 'Paid', value: 'Paid', color: 'primary', icon: 'icon-check-circle', before_status: ['GRNI', 'Invoiced'] },
            ],
            is_loading: false
        }
    },
    components: {
        'v-select': vSelect,
        flatPickr
    },
    mixins: [Filter, SuccessMessage, ErrorMessages],
    async mounted() {
        this.customerId = this.$route.params.id
        this.setDateFilters()
    },
    methods: {
        async refreshData() {
            this.is_on_create = false
            this.getProductOrderList()
        },

        async getProductOrderList() {
            this.$vs.loading()
            this.is_loading = true
            try {
                const { data } = await FinancialRepository.getListGrni(this.page, this.perPage, this.from, this.to, this.order_type ? this.order_type : '', this.payment_status ? this.payment_status : '', this.global_search ? this.global_search : '', this.sort)
                this.order_list = data.data
                this.meta = { per_page: data.per_page, total: data.total, last_page: data.last_page }
            } catch (error) {
                this.convertAndNotifyError(error)
            }
            this.is_loading = false
            this.$vs.loading.close()
        },

        async onClickProductOrderUpdate(id, customer_id) {
            // await this.$refs.updateCustomerProductOrderPopUp.openPopup(id, customer_id)
        },
        onClickCreateNewOrder() {
            this.is_on_create = true
        },

        filterQueryUpdate() {
            this.getProductOrderList()
        },

        handleChangePage(page) {
            this.page = page;
            this.getProductOrderList()
        },
        handleSort(key, active) {
            if (key) {
                active = (active === 'desc') ? "-" : '';
                this.sort = active + key;
                this.getProductOrderList()
            }
        },
        changePage(index) {
            this.perPage = this.descriptionItems[index]
        },
        ProductOrderStatusColorFactory(id) {
            switch (id) {
                case 1:
                    return 'warning';
                case 2:
                    return 'primary';
                case 3:
                    return '#f05945';
                case 4:
                    return '#f58634';
                case 5:
                    return '#206a5d';
            }
        },
        onClickFinishedProduct(id) {
            this.$router.push({ path: `/pages/formulations/${id}` })
        },
        onClickFormula(id) {
            this.$router.push({ path: `/pages/formulations/${id}` })
        },
        getColumnLink(type, order_id) {
            const linkType = {
                'Raw Material Order': `/pages/raw-materials/orders/${order_id}`,
                'Sundry Order': `/pages/sundry-items/orders/${order_id}`,
                'Other Order': `/pages/other-supplier-service/orders/${order_id}`,
            };
            return linkType[type] || '#';
        },
        onClickStatusChangeConfirm(status, order_item, order_type, order_code) {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Confirm ~ ${order_code}`,
                text: 'Are you sure you want to change payment status?',
                accept: this.onClickChangePaymentStatus,
                parameters: [status, order_item, order_type]
            })
        },
        async onClickChangePaymentStatus(params) {
            await this.$vs.loading()
            try {
                if (params[2] === 'Raw Material Order') {
                    await InventoryRepository.rmOrderItemPaymentStatusChange(params[1], params[0])
                }
                if (params[2] === 'Sundry Order') {
                    await InventoryRepository.sundryOrderItemPaymentStatusChange(params[1], params[0])
                }
                if (params[2] === 'Other Order') {
                    await InventoryRepository.otherOrderItemPaymentStatusChange(params[1], params[0])
                }
                await this.getProductOrderList()
                this.showSuccessMessage('Status change successfully!')
            } catch (error) {
                this.convertAndNotifyError(error)
            }
            this.$vs.loading.close()
        },
        async onClickRmBatchStatusChangeConfirm(status, batch_item, order_code) {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Confirm ~ ${order_code}`,
                text: 'Are you sure you want to change payment status?',
                accept: this.onClickChangeRmPaymentStatus,
                parameters: [status, batch_item]
            })
        },
        async onClickChangeRmPaymentStatus(params) {
            await this.$vs.loading()
            try {
                await InventoryRepository.rmOrderItemBatchPaymentStatusChange(params[1], params[0])
                await this.getProductOrderList()
                this.showSuccessMessage('Status change successfully!')
            } catch (error) {
                this.convertAndNotifyError(error)
            }
            this.$vs.loading.close()
        },
        search: _.debounce(async (vm) => {
            vm.getProductOrderList()
        }, 500),
        calculateTotalOrderValue(items) {
            const total = items.reduce((pre, cur) => pre + Number(cur.price) * Number(cur.quantity), 0)
            return Number(total).toFixed(2)
        },
        calculateGrniTotal(items, order_type) {
            if (order_type === 'Raw Material Order') {
                let total = 0
                items.forEach((item) => {
                    let unit_price = item.price
                    let batches_total = item.batches.filter((x) => ['GRNI'].includes(x.payment_status))
                        .reduce((pre, cur) => pre + Number(unit_price) * Number(cur.quantity), 0)
                    total = total + batches_total
                })
                return Number(total).toFixed(2)
            } else if(order_type === 'Sundry Order') {
                const total = items
                    .filter((x) => ['GRNI'].includes(x.payment_status))
                    .reduce((pre, cur) => pre + Number(cur.price) * (Number(cur.quantity) - Number(cur.quantity_pending_to_receive)), 0)
                return Number(total).toFixed(2)
            } else {
                const total = items.filter((x) => ['GRNI'].includes(x.payment_status))
                    .reduce((pre, cur) => pre + Number(cur.price) * Number(cur.quantity), 0)
                return Number(total).toFixed(2)
            }
        },
        calculateNotGrniTotal(items) {
            const total = items.reduce((pre, cur) => pre + Number(cur.price) * Number(cur.quantity_pending_to_receive ? cur.quantity_pending_to_receive : cur.quantity), 0)
            return Number(total).toFixed(2)
        },
        calculateAlreadyInvoicedTotal(items, order_type) {
            if (order_type === 'Raw Material Order') {
                let total = 0
                items.forEach((item) => {
                    let unit_price = item.price
                    let batches_total = item.batches.filter((x) => ['Invoiced', 'Paid'].includes(x.payment_status))
                        .reduce((pre, cur) => pre + Number(unit_price) * Number(cur.quantity), 0)
                    total = total + batches_total
                })
                return Number(total).toFixed(2)
            } else if(order_type === 'Sundry Order') {
                const total = items
                    .filter((x) => ['Invoiced', 'Paid'].includes(x.payment_status))
                    .reduce((pre, cur) => pre + Number(cur.price) * (Number(cur.quantity) - Number(cur.quantity_pending_to_receive)), 0)
                return Number(total).toFixed(2)
            } else {
                const total = items
                    .filter((x) => ['Invoiced', 'Paid'].includes(x.payment_status))
                    .reduce((pre, cur) => pre + Number(cur.price) * (Number(cur.quantity)), 0)
                return Number(total).toFixed(2)
            }
        },
        calculateAlreadyInvoicedTotalQuantity(items, order_type) {
            if (order_type === 'Raw Material Order') {
                let total = 0
                items.forEach((item) => {
                    let batches_total = item.batches.filter((x) => ['Invoiced', 'Paid'].includes(x.payment_status))
                        .reduce((pre, cur) => pre +  Number(cur.quantity), 0)
                    total = total + batches_total
                })
                return Number(total).toFixed(2)
            } else if(order_type === 'Sundry Order') {
                const total = items
                    .filter((x) => ['Invoiced', 'Paid'].includes(x.payment_status))
                    .reduce((pre, cur) => pre + Number(cur.price) * (Number(cur.quantity) - Number(cur.quantity_pending_to_receive)), 0)
                return Number(total).toFixed(2)
            } else {
                const total = items
                    .filter((x) => ['Invoiced', 'Paid'].includes(x.payment_status))
                    .reduce((pre, cur) => pre + Number(cur.price) * (Number(cur.quantity)), 0)
                return Number(total).toFixed(2)
            }
        },
        currencySymbolGenerator(currency) {
            return this.__currencySymbol(currency)
        },
        async onClickClearFilters() {
            this.setDateFilters()
            this.order_type = null
            this.payment_status = null
            this.global_search = null
            await this.getProductOrderList()
        },
        setDateFilters() {
            const today = moment(); 
            this.to = today.format('DD/MM/YYYY');
            const dateOneYearAgo = today.clone().subtract(1, 'year');
            this.from = dateOneYearAgo.format('DD/MM/YYYY'); 
        },
        itemPaymentStatusGenerator(order_type, payment_status, batches) {
            if(order_type === 'Raw Material Order') {
                const firstPaymentStatus = batches.length > 0 ? batches[0].payment_status : null;
                const allSame = batches.every(obj => obj.payment_status === firstPaymentStatus);
                return allSame ? firstPaymentStatus : "multiple status";
            } else {
                return payment_status
            }
        },
        itemStatusGenerator(order_type, status, qc_tests, quantity_pending_to_receive) {
            if (status.includes('Received -') && order_type === 'Raw Material Order') {
                if (qc_tests.length === 0) {
                    return status;
                }
                const firstStatus = qc_tests[0].qc_test.q_c_status;
                const allSame = qc_tests.every(obj => obj.qc_test.q_c_status === firstStatus);
                if (Number(quantity_pending_to_receive) !== 0 || !allSame) {
                    return 'Received - multiple QC status';
                }
                return `Received - QC ${firstStatus}`;
            }
            return status;
        },
        
        checkItemStatus(items) {
            const firstStatus = items[0] && items[0].payment_status
            return ['GRNI', 'Invoiced'].includes(firstStatus) && items.every(item => item.payment_status === firstStatus)
        },
        isRootStatusChangeButtonVisible(data, to_payment_status) {
            const status_obj = this.payment_status_list.find((x) => x.name === to_payment_status)
            if (!status_obj) return false
            // Multi-item non-RM: all items must have a before_status payment_status
            if (data.items.length > 1 && data.type !== 'Raw Material Order') {
                if (to_payment_status === 'Paid' && this.checkItemStatus(data.items)) return true
                if (to_payment_status === 'Invoiced' || to_payment_status === 'GRNI') return data.items.every(item => status_obj.before_status.includes(item.payment_status))
                return false
            }
            // Multi-item RM: derive each item's effective status from its batches (same logic as itemPaymentStatusGenerator)
            if (data.items.length > 1 && data.type === 'Raw Material Order') {
                const getEffectiveStatus = function(item) {
                    if (!item.batches || item.batches.length === 0) return null
                    const first = item.batches[0].payment_status
                    return item.batches.every(function(b) { return b.payment_status === first }) ? first : null
                }
                const processedItems = data.items.filter(function(item) { return !!getEffectiveStatus(item) })
                if (processedItems.length === 0) return false
                const firstStatus = getEffectiveStatus(processedItems[0])
                if (!status_obj.before_status.includes(firstStatus)) return false
                return processedItems.every(function(item) { return getEffectiveStatus(item) === firstStatus })
            }
            if(data.type !== 'Raw Material Order') return false
            const item = data.items[0]
            const batches = item.batches
            if(!batches || batches.length === 0) return false
            if(batches.length > 1) {
                const firstBatchStatus = batches[0] && batches[0].payment_status
                return status_obj.before_status.includes(firstBatchStatus) && batches.every(function(b) { return b.payment_status === firstBatchStatus })
            }
            if(batches.length !== 1) return false
            if(!status_obj.before_status.includes(batches[0].payment_status)) return false
            return true
        },
        async changeStatusRootLevel(data, status) {
            if (data.items.length !== 1) {
                this.$vs.loading()
                try {
                    const promises = data.items.map((item) => {
                        if (data.type === "Raw Material Order") return InventoryRepository.rmOrderItemPaymentStatusChange(item.id, status)
                        if (data.type === "Sundry Order") return InventoryRepository.sundryOrderItemPaymentStatusChange(item.id, status)
                        if (data.type === "Other Order") return InventoryRepository.otherOrderItemPaymentStatusChange(item.id, status)
                    })
                    await Promise.all(promises)
                    await this.getProductOrderList()
                    this.showSuccessMessage("Status change successfully!")
                } catch (error) {
                    this.convertAndNotifyError(error)
                } finally {
                    this.$vs.loading.close()
                }
            } else {
                const batches = data.items[0] && data.items[0].batches ? data.items[0].batches : []
                if (batches.length > 0) {
                    this.$vs.loading()
                    try {
                        await Promise.all(batches.map((batch) => InventoryRepository.rmOrderItemBatchPaymentStatusChange(batch.id, status)))
                        await this.getProductOrderList()
                        this.showSuccessMessage("Status change successfully!")
                    } catch (error) {
                        this.convertAndNotifyError(error)
                    } finally {
                        this.$vs.loading.close()
                    }
                }
            }
        },
        itemCount(data) {
            if(data.items && data.items.length && data.items[0].batches) {
                return data.items[0].batches.length
            }
            if(data.items && data.items.length && !data.items[0].batches) {
                return data.items.length
            }
        }
    },
    watch: {
        page() {
            this.getProductOrderList()
        },
        perPage() {
            this.page = 1
            this.getProductOrderList()
        },
        from() {
            this.page = 1
            this.getProductOrderList()
        },
        to() {
            this.page = 1
            this.getProductOrderList()
        },
        order_type() {
            this.page = 1
            this.getProductOrderList()
        },
        payment_status() {
            this.page = 1
            this.getProductOrderList()
        },
        global_search() {
            this.page = 1
            this.search(this);
        }
    },
    computed: {
        fixed_filters () {
            return {
                order_type: this.order_type ? this.order_type : null,
                from: this.from,
                to: this.to,
                search: this.global_search,
                payment_status: this.payment_status
            }
        }
    }
}
</script>
  
  
<style scoped>
.user-edit-popup>>>.vs-popup {
    min-height: 50% !important;
    min-width: 50% !important;
}

@media (min-width: 768px) and (max-width: 1319px) {
    .user-edit-popup>>>.vs-popup {
        min-height: 50% !important;
        min-width: 65% !important;
    }
}

table td {
    vertical-align: top;
    min-width: 140px;
    padding-bottom: .8rem;
    word-break: break-all;
}
</style>
  